export default function SuperHopIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="12" fill="#69b7ff" />
      <rect x="2" y="50" width="60" height="12" fill="#a0622d" />
      <rect x="2" y="48" width="60" height="5" fill="#4cc94a" />
      <rect x="40" y="10" width="16" height="16" rx="4" fill="#f05cb8" stroke="#7a2f8f" strokeWidth="2" />
      <rect x="46" y="11" width="4" height="14" fill="#4fe0d0" />
      <rect x="41" y="16" width="14" height="4" fill="#4fe0d0" />
      <path d="M48 13.5 L49.4 16.6 L52.6 16.9 L50.2 19 L50.9 22.2 L48 20.6 L45.1 22.2 L45.8 19 L43.4 16.9 L46.6 16.6 Z" fill="#fff6a8" stroke="#c47a12" strokeWidth="0.6" />
      <rect x="15" y="10" width="6" height="16" rx="3" fill="#f4efe6" transform="rotate(-12 18 18)" />
      <rect x="23" y="10" width="6" height="16" rx="3" fill="#f4efe6" transform="rotate(14 26 18)" />
      <rect x="17" y="12" width="2.5" height="10" rx="1" fill="#ffb3c6" transform="rotate(-12 18 18)" />
      <rect x="25" y="12" width="2.5" height="10" rx="1" fill="#ffb3c6" transform="rotate(14 26 18)" />
      <circle cx="23" cy="30" r="9" fill="#f4efe6" />
      <rect x="15" y="36" width="16" height="12" rx="6" fill="#f4efe6" />
      <rect x="14" y="36" width="18" height="4" fill="#2f8bff" />
      <circle cx="26" cy="29" r="1.8" fill="#222" />
      <circle cx="30.5" cy="32" r="1.5" fill="#ff7aa2" />
    </svg>
  );
}
